<template>
  <div id="app">
    <Header />
    <!--  <keep-alive> -->
    <router-view />
    <!--</keep-alive> -->
    <Footer />
  </div>
</template>
<script>
import Header from "../src/components/Header.vue";
import Footer from "../src/components/Footer.vue";
export default {
  data: () => {
    return {};
  },
  methods: {},
  components: {
    Header,
    Footer,
  },
};
</script>
<style lang="postcss" scoped>
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-size: auto;
}
</style>
